import clsx from "clsx";
import { CameraIcon, TrashIcon } from "@heroicons/react/24/outline";

type PhotoCaptureBoxProps = {
  inputId: string;
  isParsing: boolean;
  hasCapturedPhoto: boolean;
  disabled?: boolean;
  idleText: string;
  parsingText: string;
  onReset: () => void;
};

export default function PhotoCaptureBox({
  inputId,
  isParsing,
  hasCapturedPhoto,
  disabled = false,
  idleText,
  parsingText,
  onReset,
}: PhotoCaptureBoxProps) {
  const interactive = !isParsing && !disabled && !hasCapturedPhoto;
  const cursorClass = isParsing
    ? "cursor-wait"
    : interactive
      ? "cursor-pointer"
      : "cursor-default";

  return (
    <label
      htmlFor={interactive ? inputId : undefined}
      className={clsx(
        "border border-dashed rounded-lg w-full flex items-center justify-center transition",
        interactive
          ? "border-blue-500 hover:bg-blue-100"
          : "border-gray-300 bg-gray-50",
        cursorClass,
      )}
    >
      {isParsing ? (
        <div className="h-16 flex items-center justify-center">
          <p className="text-gray-500 text-base font-medium animate-pulse">
            {parsingText}
          </p>
        </div>
      ) : hasCapturedPhoto ? (
        <div
          className="flex items-center justify-between p-3 w-full"
          onClick={(e) => e.stopPropagation()}
        >
          <p className="text-base text-gray-700 font-medium pl-2">
            Photo captured
          </p>
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onReset();
            }}
            className="p-2 mr-2 text-red-500 hover:bg-red-100 rounded-full transition-colors cursor-pointer"
            title="Remove photo"
          >
            <TrashIcon className="h-6 w-6" />
          </button>
        </div>
      ) : (
        <p className="flex items-center h-16 gap-3 text-blue-500 text-sm md:text-base font-medium">
          <CameraIcon className="h-6 w-6" />
          {idleText}
        </p>
      )}
    </label>
  );
}
